<template>
  <v-container fluid>
    <v-card>
      <v-card-title primary-title>
        <span class="headline mb-0">Invoice変更・取消詳細</span>
      </v-card-title>

      <v-card-actions>
        <v-btn @click="$router.go(-1)">戻る</v-btn>
        <v-btn
          @click="mergeInv"
          v-if="$route.query.status==='UPDATE'"
          v-permit.SHARP_ICD_CONFLICT
        >Invoice書換</v-btn>
        <v-btn
          @click="cancelInv"
          v-if="$route.query.status==='CANCEL'"
          v-permit.SHARP_ICD_CANCEL
        >Invoice取消</v-btn>
      </v-card-actions>
    </v-card>
    <inv-list :no="$route.query.no"></inv-list>
    <sa-list :no="$route.query.no"></sa-list>
    <do-list :no="$route.query.no"></do-list>
    <!-- <sa-detail :id="$route.query.id" class="mt-2"/>
    <sa-detail :conflictId="$route.query.id" class="mt-2"/>-->
    <!-- <do-list :id="$route.query.id"></do-list> -->
  </v-container>
</template>
<script>
import InvList from './InvList'
import SaList from './SaList'
import DoList from './DoList'
export default {
  components: { InvList, SaList, DoList },
  data() {
    return {
      form: {},
      headers: [],
      results: [],
      selected: [],
      loading: false,
      pagination: {
        rowsPerPage: 10
      },
      errors: {
        INVALID_SA_STATUS: 'S/A取消してください。',
        INVALID_STATUS: 'D/O取消してください。',
        PACKAGE_QTY_OVER: 'POの発注数量を超えてしまう、ご確認ください。',
        INVALID_INV_STATUS: 'I/V取消してください'
      }
    }
  },
  methods: {
    cancelInv() {
      this.$http
        .post(`/commercial-invoices/${this.$route.query.id}/cancel-invoice`)
        .then(() => {
          this.$message('', '取消成功')
        })
        .catch(res => {
          this.showError(res)
        })
    },
    mergeInv() {
      this.$http
        .post(`commercial-invoices/${this.$route.query.id}/merge-invoice`)
        .then(() => {
          this.$message('', 'INV替换成功')
        })
        .catch(res => {
          this.showError(res)
        })
    },
    showError(res) {
      if (this.errors[res.response.data.message]) {
        this.$message(
          this.$t('app.messages.errors.title'),
          this.errors[res.response.data.message]
        )
      } else {
        this.$message(this.$t('app.messages.errors.title'), 'System Error.')
      }
    }
  }
}
</script>

